import { render, staticRenderFns } from "./PayAgree.vue?vue&type=template&id=a39238e2&scoped=true&"
import script from "./PayAgree.vue?vue&type=script&lang=js&"
export * from "./PayAgree.vue?vue&type=script&lang=js&"
import style0 from "./PayAgree.vue?vue&type=style&index=0&id=a39238e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39238e2",
  null
  
)

export default component.exports